import { render } from "./CIS-Home-Blockquote-Item.vue?vue&type=template&id=bfd16304&scoped=true"
import script from "./CIS-Home-Blockquote-Item.vue?vue&type=script&lang=js"
export * from "./CIS-Home-Blockquote-Item.vue?vue&type=script&lang=js"

import "./CIS-Home-Blockquote-Item.vue?vue&type=style&index=0&id=bfd16304&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd16304"]])

export default __exports__